import { useEffect, useRef } from 'react'
import { EventType } from '../../../constants'
import { useEventTracking } from '../../../hooks'
import { FormMissingParametersEventData } from '../../../types'

interface Props {
  eventType?: EventType
  invalidParameters: string[]
}

const useTrackReservationMissingParameters = ({ eventType, invalidParameters }: Props) => {
  const { track: trackEvent } = useEventTracking()
  const previousDataRef = useRef<string[]>([])

  useEffect(() => {
    if (!eventType) return
    if (!invalidParameters.length) return

    const hasChanged = JSON.stringify(invalidParameters) !== JSON.stringify(previousDataRef.current)

    if (!hasChanged) return

    const data: FormMissingParametersEventData = {
      isInitialValid: false,
      missingParameters: invalidParameters,
    }

    trackEvent(eventType, { data })
    previousDataRef.current = invalidParameters
  }, [eventType, invalidParameters, trackEvent])
}

export { useTrackReservationMissingParameters }
